import React, { memo, useMemo } from 'react';
import { func, bool } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTLabel } from '@widergy/energy-ui';
import { required } from '@widergy/web-utils/lib/validate';

import { appConfig } from 'config/customization';
import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { SOCIAL_RATE_QUERY } from 'constants/reduxForms';
import UTSelectInput from 'app/components/UTSelectInput';
import { accountPropTypes } from 'redux/accountHandlers';
import { clientNumberField } from 'constants/fields';

import styles from './styles';

const fields = [clientNumberField];

const validations = [required(message('Validations:required'))];

function QueryForm({ handleSubmit, options, isPublicRequest }) {
  const addressWithNISOptions = useMemo(
    () =>
      options &&
      options.map(option => option.merge({ address: `${option.client_number} - ${option.address}` })),
    [options]
  );

  return (
    <div>
      <div style={styles.formTitle}>
        <UTLabel style={styles.textInputSize}>
          {appConfig.socialRate.manualInput || isPublicRequest
            ? message('SocialRate:formTitle')
            : message('SocialRate:formSelectorTitle')}
        </UTLabel>
      </div>
      <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} style={styles.form}>
        {appConfig.socialRate.manualInput || isPublicRequest ? (
          <UTForm fields={fields} />
        ) : (
          <Field
            component={UTSelectInput}
            placeholder={message('SocialRate:formSelectorPlaceholder')}
            options={addressWithNISOptions}
            keyProp="id"
            labelKey="address"
            valueKey="client_number"
            withOrder
            name="clientNumber"
            validate={validations}
          />
        )}
      </form>
    </div>
  );
}

QueryForm.propTypes = {
  handleSubmit: func.isRequired,
  options: accountPropTypes,
  isPublicRequest: bool
};

export default reduxForm({ form: SOCIAL_RATE_QUERY })(memo(QueryForm));
